export const establishmentFeeColumns = [
    { label: "Nome", value: "name" },
    { label: "Produto", value: "product" },
    { label: "Valor", value: "amount"},
  ];
  
  